import React from 'react';
interface SectionHeadingProps {
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  action?: React.ReactNode;
  id?: string;
  as?: 'h1' | 'h2';
}
export function SectionHeading({
  title,
  intro,
  tone = 'light',
  align = 'left',
  action,
  id,
  as = 'h2'
}: SectionHeadingProps) {
  const Heading = as;
  const titleColor = tone === 'dark' ? 'text-white' : 'text-navy';
  const introColor = tone === 'dark' ? 'text-chrome-300' : 'text-steel';
  const centered = align === 'center';
  return <div className={`flex flex-col gap-6 ${action ? 'md:flex-row md:items-end md:justify-between' : ''} ${centered ? 'items-center text-center' : ''}`} data-id="element-567" data-mp="i6n3ccb4dvh2">
      <div className={`max-w-[60rem] ${centered ? 'mx-auto flex flex-col items-center' : ''}`} data-id="element-568" data-mp="8ajvcptl72m7">
        <Heading id={id} className={`t-h2 ${titleColor}`} data-id="element-569" data-mp="48gflozvxbv4">
          {title}
        </Heading>
        <span className="red-rule mt-5" aria-hidden="true" data-id="element-570" data-mp="3vdyfr0smahc8" />
        {intro && <p className={`t-lead mt-5 max-w-[48rem] ${introColor}`} data-id="element-571" data-mp="1e0j7yebtne2m">{intro}</p>}
      </div>
      {action && <div className="shrink-0" data-id="element-572" data-mp="1ir9cjpcfbcw9">{action}</div>}
    </div>;
}